import { z } from 'zod';

import { apiClient } from './client';

// Зеркалит backend InspectionResource: status из App\Enums\InspectionStatus
// (draft/submitted/accepted/disputed), дата приёмки = performed_at (nullable),
// а НЕ scheduled_at (его бэкенд не отдаёт). Раньше схема была полностью
// расхождена -> любой осмотр ронял парсинг списка.
export const InspectionZ = z.object({
  id: z.number().int(),
  lease_id: z.number().int(),
  type: z.string().optional(),
  status: z.enum(['draft', 'submitted', 'accepted', 'disputed']),
  performed_at: z.string().nullable().optional(),
  notes: z.string().nullable().optional(),
});
export type Inspection = z.infer<typeof InspectionZ>;

const ListZ = z.object({ data: z.array(InspectionZ) });

export async function listInspections(params: { lease_id?: number } = {}): Promise<Inspection[]> {
  const res = await apiClient.get('/inspections', { params });
  return ListZ.parse(res.data).data;
}

export const inspectionsApi = { list: listInspections };
